var render = function render(){var _vm=this,_c=_vm._self._c;return _c('tr',{class:[{ 'is-clickable': _vm.clickable, 'is-selected': _vm.selected }, _vm.rowClass],on:{"click":function($event){return _vm.$emit('select', _vm.item)}}},[_vm._t("default",null,{"item":_vm.item})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }